<template>
  <t-page>
    <template #header>
      <h3>{{ $t('pages.pings.heading') }}</h3>
    </template>
    <t-grid>
      <t-grid-cell>
        <index-table
          :query="query"
          :fields="fields"
        />
      </t-grid-cell>
    </t-grid>
  </t-page>
</template>

<script>
import Vue from 'vue';
import Ping from '~/models/Ping';
import IndexTable from '~/pages/shared/pings/partials/IndexTable';

export default Vue.extend({
  components: { IndexTable },

  middleware: 'employee',

  data: () => ({
    fields: ['sent_at', 'applicant_fullname'],
  }),

  methods: {
    query() {
      return new Ping().include('applicant.user', 'organization');
    },
  },
});
</script>
